<div class="arcgis-custom-map-form-wrapper">
  <!--ArcGis map service-->

  <form [formGroup]="arcGisCustomMapForm">
    <div class="arcGis-fields">
      <div class="form-row">
        <mat-form-field>
          <mat-select
            name="securityType"
            formControlName="securityType"
            [required]="true"
            placeholder="{{ 'sources.details.Security' | translate }}">
            <mat-option *ngFor="let type of securityTypes" [value]="type.value">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="getControlRequiredError('securityType')"
          >{{ 'validation.required' | translate:{name: ('company.baseMaps.mapType' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>


      <div class="form-row">
        <mat-form-field>
          <input matInput formControlName="mapServerUrl" name="mapServerUrl"
                 placeholder="{{ 'company.baseMaps.mapServerUrl' | translate }}"
                 [required]="true"/>
          <mat-error
            *ngIf="getControlRequiredError('mapServerUrl')"
          >{{ 'validation.required' | translate:{name: ('company.baseMaps.mapServerUrl' | translate)} }}
          </mat-error>
          <mat-error
            *ngIf="arcGisCustomMapForm.get('mapServerUrl').errors && arcGisCustomMapForm.get('mapServerUrl').errors.notUnique">
            {{ 'company.baseMaps.customMapUniqueMapServerUrl' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row"
           [class.hidden]="!isArcGisPassword()">
        <mat-form-field>
          <input matInput formControlName="authUrl" name="AuthenticationUrl"
                 [required]="isArcGisPassword()"
                 placeholder="{{ 'sources.fields-placeholders.AuthenticationUrl' | translate }}"/>
          <mat-error
            *ngIf="getControlRequiredError('authUrl')"
          >{{ 'validation.required' | translate:{name: ('sources.fields-placeholders.AuthenticationUrl' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>


      <div class="form-row"
           [class.hidden]="(!isArcGisPassword() || !arcGisCustomMapForm.get('authUrl').value)">
        <mat-form-field>
          <input matInput
                 [type]="'text'"
                 formControlName="username" name="username"
                 [required]="isArcGisPassword() && arcGisCustomMapForm.get('authUrl').value !== ''"
                 placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"/>
          <mat-error
            *ngIf="getControlRequiredError('username')"
          >{{ 'validation.required' | translate:{name: ('sources.fields-placeholders.Username' | translate)} }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input type="password" matInput
                 [required]="isArcGisPassword() && !isUpdateMode"
                 formControlName="password" name="password"
                 placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"/>
          <mat-error
            *ngIf="getControlRequiredError('password')"
          >{{ 'validation.required' | translate:{name: ('sources.fields-placeholders.Password' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="optional-inputs arcGisOnline" fxLayout="column" fxLayout.gt-md="row">
        <mat-slide-toggle formControlName="isArcGisOnline" name="isArcGisOnline" color="primary">
          {{ 'sources.fields-placeholders.IsArcGisOnline' | translate }}
        </mat-slide-toggle>
      </div>

    </div>
  </form>


  <!--End ArcGis map service-->
</div>
